import { atom } from 'jotai'
import { Sheet } from 'types/types'

export const sheetAtom = atom<Sheet>({} as Sheet)
